import React , { useState , useRef , useEffect } from 'react'

import Select from 'react-select';

import { ApiCallGet } from '../ApiCall/ApiCall';

var options = [
 
]

export default function MessagesSent() {
    const [theOptions,setTheOptions] = useState([])
    const [campainSelected,setCampainSelected] = useState(null)
    const [fecha,setFecha] = useState(null)
    const [elements,setElements] = useState([]) // Los dejamos en vacio al inicio

    const selectRef = useRef(null)
    //const labelRef = useRef(null)

    function onFechaChange( val )
    {
        console.log( "fecha = " + val.target.value )
        setFecha( val.target.value )
    }

    function onSeleccionar()
    {
        if ( fecha === null ){
            alert( "Seleccione una fecha" )
            return ;
        }

        if( campainSelected === null ){
            alert( "Seleccione una campaña" )
            return ;
        }

        console.log( "fecha = " + fecha )
        console.log( "campainSelected = " + campainSelected )  

        // smscampaindate , campain , date 

        ApiCallGet('smscampaindate?campain=' + campainSelected + '&date=' + fecha )
        .then( (response) => {
            console.log( response )
            setElements( response )
        } )
        .catch( (error) => {
            console.log( error )
        } )
    }

    function onSelectCampain( val )
    {
        console.log( "val = " + val.value )
        console.log( "label = " + val.label )


        setCampainSelected( val.value ) // Datos de la campaña seleccionada
    }

    useEffect( () => {

        ApiCallGet('getcampains')
        .then( (response) => {
          //console.log( "Nos esta llegando la respuesta")
          //console.log( response )
          for( var i = 0 ; i < response.length ; i++ ){
            options.push({ value : response[i].id, label : response[i].name })
          }
          setTheOptions( options )
        } )
        .catch( (error) => {
          console.log( error )
        })
    
    
      } , [] )
    

  return (
    <div className='d-flex flex-column  justify-content-center box-1 backemployer-2 centersearch' >

        <div className='d-flex flex-column  justify-content-center box-1 backemployer-2 centersearch' >
            <h3 className='text-center'>Digital Mensajes Enviados</h3>
        </div>

        <div className='row' style={{height: elements.length > 0 ? '' : '80vh'}}>

            <div className='col-4' >
                <label className="form-label m-0" htmlFor="campana">Seleccione Campaña</label>
                <Select ref={selectRef}  options={theOptions} id="campaña" className="form-control"
                    placeholder="Seleccione una campaña" onChange={onSelectCampain}/>  

            </div> 


        

            <div className='col-sm-2'>

            </div>

            <div className='col-3'>
                  <label className="form-label m-0" htmlFor="fecha">Fecha Inicio</label>
                  <input type="date" className="form-control" id="fecha" onChange={onFechaChange}  />
            </div>

            <div className='col-sm-2'>

                <button type='button' style={{borderRadius:'8px', marginTop : '24px'}}
                    onClick={onSeleccionar}>Seleccionar</button>

            </div>
        </div>


        <div className='row mt-5'>
              <div className='col-12'>
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Index</th>
                      <th scope="col">Telefono</th>
                      <th scope="col">Nombre</th>
                      <th scope="col">Respuesta</th>
                      <th scope="col">FechaEnvio</th>
                    </tr>
                  </thead>
                  <tbody>

                  {elements.map((value,index) => {
                      //return <input key={index} onChange={(val)=>{onchangeInput(val, index)}} /> 
                      return     <tr key={index}>
                      <th scope="row">{index+1}</th>
                      <td>{value.telefono}</td>
                      <td>{value.nombre}</td>
                      <td>{value.respuesta}</td>
                      <td>{value.fechaenvio}</td>
                       {/*<td className='ps-0'><input key={index} onChange={(val)=>{onchangeInput(index)}}  type='checkbox'></input></td>
                      <td><input key={index}   type='checkbox'></input></td> */}
                    </tr> ;
                  })}
                  </tbody>
                </table>
              </div>
            </div>

        
    </div>
  )
}
